module.exports = __webpack_public_path__ + "static/media/veasna_lee.d511e3e2.jpg";